/* eslint-disable react/destructuring-assignment */
import React, { FC, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";

import { sanitizeHtml } from "@/core/security";
import { getFilesApi } from "@/shared/apis/apiRoot";

import { StyledTermsDialog } from "./styled";

type TermsType = "termsOfUse" | "customerTermsOfUse";

type TermsOfUseDialogProps = {
    type?: TermsType;
    onClose: () => void;
};

const TermsOfUseDialog: FC<TermsOfUseDialogProps> = ({ onClose, type = "termsOfUse" }) => {
    const { t, i18n } = useTranslation();
    const [template, setTemplate] = useState("");

    useEffect(() => {
        getFilesApi()
            .get<string>(`/files/${type}-${i18n.language}.html`)
            .then((response) => {
                setTemplate(response.data);
            });
    }, [i18n.language]);

    return (
        <Dialog open onClose={onClose}>
            <StyledTermsDialog>
                <div
                    className="termsFrame"
                    data-testid="termsFrame"
                    dangerouslySetInnerHTML={{ __html: sanitizeHtml(template) }}
                />

                <div className="containerButtons">
                    <Button type="button" style={{ minWidth: "150px" }} onClick={onClose} data-testid="confirm-terms">
                        {t("Common.Ok")}
                    </Button>
                </div>
            </StyledTermsDialog>
        </Dialog>
    );
};

export default TermsOfUseDialog;
